import { Card, Col, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Page from "../../../common/components/Page";
import { RootState } from "../../../store";
import CaseSummaryCase from "./case-summary-case";
import CaseSummaryPerson from "./case-summary-person";
import CaseSummaryViolations from "./case-summary-violations";
import getConfigs from "../../../GetConfigs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CaseSummary = () => {
  const { caseMaster } = useSelector((state: RootState) => state.global);
  const [form] = Form.useForm();

  useEffect(() => {
    const summaryData = caseMaster?.summary?.MAIN[0];
    form.setFieldsValue({ ...summaryData });
  }, [caseMaster?.summary?.MAIN, form]);

  const [messageVisible, setMessageVisible] = useState<boolean>(true)
  const configurations = getConfigs([
    "ctTRCRSummaryTxt",
  ]);

  return (
    <Page>
      <Page.Content>
        <Row gutter={[16, 16]}>
        {configurations.ctTRCRSummaryTxt && messageVisible && (
          <Col xl={23} lg={23} md={24} sm={24} xs={24}>
            <Card>
              <div style={{ display:"flex", justifyContent:"flex-end", alignItems:"end"} }>
                <FontAwesomeIcon icon={"times"} onClick={() => setMessageVisible(false)} />
              </div>
              <br/>
              <div dangerouslySetInnerHTML={{ __html: configurations.ctTRCRSummaryTxt }} />
            </Card>
          </Col>
        )}
          <Col xl={11} lg={11} md={11} sm={24} xs={24}>
            <CaseSummaryPerson form={form} />
          </Col>
          <Col xl={12} lg={12} md={12} sm={24} xs={24}>
            <CaseSummaryCase form={form} />
          </Col>
          <Col xl={23} lg={23} md={24} sm={24} xs={24}>
            <CaseSummaryViolations data={caseMaster?.summary?.LIST} />
          </Col>
        </Row>
      </Page.Content>
    </Page>
  );
};

export default CaseSummary;
